module.exports = __webpack_public_path__ + "static/media/luzia.3b25ea00.jpg";